module.exports = __webpack_public_path__ + "static/sharing-fcf0f6cedb8b3f8f1613906aab57a6b0.png";